import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../apiservices/apiservices';
import { ResponseStructure } from "./formbeneficios.type";

type FrontendPromiseResult<T> = Promise<{Item: T | any, erro: string}>;

@Injectable()

export class FormBeneficiosProvider {
  private header=APIService.getHeader();
  private endpoint = `${APIService.API_URL}formbeneficios`
  itemret;

  constructor(public http: HttpClient) {
  }

  /**
   * Lista usuários
   * @param idFormulario busca apenas pelo formulário em questão
   * @returns
   */
  get<T>(idFormulario: string = null, idAtividade: string = null, filtros = {}): Promise<ResponseStructure<T>> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {

      let url = new URL(this.endpoint);

      if(idFormulario)
      {

        // url += `?id=${idFormulario}`

        url.searchParams.append('id', idFormulario);

      }
      else if(idAtividade)
      {
        // url += `?idatividade=${idAtividade}`
        url.searchParams.append('idatividade', idAtividade);

      }

      if (Object.keys(filtros).length > 0) {
        // const queryParams = new URLSearchParams();
        for (const key in filtros) {
          if (filtros.hasOwnProperty(key)) {
            // url += `&${key}=${filtros[key]}`;
            url.searchParams.append(key, filtros[key]);
            //queryParams.append(key, filtros[key]);
          }
        }
      }

      me.http.get(url.toString(),{headers:me.header})
        .subscribe((result: ResponseStructure<T>) => {
          resolve(result);
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);

        });
    });
  }

  /**
   * Cria ou atualiza formulário
   * @param dadosJson json com os dados do formulário
   * @param params parâmetros dados do formulário
   * @returns
   */
  addupdate(dadosJson:any, params = {}): FrontendPromiseResult<any> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {

      let url = this.endpoint;
      //console.log(requestData);
      me.http.post(url,dadosJson,{headers:me.header, params})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              //console.log(jsonData.erro);
              var errodatavazio={
                'Item':null,
                'erro':'Erro na atualização da empresa.'
              }
              me.itemret=errodatavazio;
            }

            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);

        });
    });
  }

}
